import { type FC, useCallback } from 'react';
import type { Analytics } from '@mwl/core-lib';
import { useSportItemsCount, useSportUrlParams } from '@mwl/core-lib';
import { Button } from '@/components/Button/Button';
import { Image } from '@/components/Image/Image';
import { internationalIcon } from '@/constants';
import { ChampionshipList } from '../ChampionshipList/ChampionshipList';
import { getSportCategoryItemAnalytics } from './SportCategoryItem.analytics';
import type { SportCategoryItemProps } from './SportCategoryItem.types';
import styles from './SportCategoryItem.module.scss';
export const SportCategoryItem: FC<SportCategoryItemProps> = ({
  id,
  title,
  icon,
  onClick,
  href,
  code,
  categories,
  sportId,
  ...rest
}) => {
  const {
    categoryId: queryCategoryId,
    stage,
    sportId: querySportId,
    championshipId: queryChampionshipId
  } = useSportUrlParams();
  const isOutrightInTotalEnabled = !!((querySportId || queryCategoryId || queryChampionshipId) && (!stage || stage !== 'OUTRIGHT'));
  const count = useSportItemsCount({
    linesCount: rest.linesCount,
    stage,
    isOutrightInTotalEnabled
  });
  const isSelected = queryCategoryId === String(id);
  const getAnalyticsData = useCallback((): Analytics<'click'> => {
    const {
      categoryAnalytics
    } = getSportCategoryItemAnalytics({
      id,
      sportId,
      categoryId: queryCategoryId ?? '',
      href,
      title,
      categories
    });
    if (isSelected) {
      return {
        click: {
          eventName: categoryAnalytics.unselect?.eventName,
          data: categoryAnalytics.unselect?.data
        }
      };
    }
    return {
      click: {
        eventName: categoryAnalytics.select?.eventName,
        data: categoryAnalytics.select?.data
      }
    };
  }, [categories, queryCategoryId, href, id, isSelected, sportId, title]);
  return <div className={styles.root} data-sentry-component="SportCategoryItem" data-sentry-source-file="SportCategoryItem.tsx">
      <Button className={cn(styles.button, {
      [styles.active]: isSelected
    })} as="link" href={href} align="left" fullWidth variant="text" onClick={onClick} shallow analytics={getAnalyticsData()} data-sentry-element="Button" data-sentry-source-file="SportCategoryItem.tsx">
        <span className={styles.imgWrapper}>
          <Image src={icon ?? internationalIcon} className={styles.img} fill alt={title || 'category'} data-sentry-element="Image" data-sentry-source-file="SportCategoryItem.tsx" />
        </span>
        <span className={styles.title}>{title}</span>
        <span className={styles.count}>{count}</span>
      </Button>

      <ChampionshipList categoryId={String(id)} data-sentry-element="ChampionshipList" data-sentry-source-file="SportCategoryItem.tsx" />
    </div>;
};